import FormControl from '@material-ui/core/FormControl'
import React from 'react'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import {onUnknownChangeHandler} from 'lib/dom'
import {useAreas} from 'lib/event-api/areas/use-areas'

export default function AreaSelect(props: {
  onPick: (id: string) => void
  value: string | null
  required?: boolean
}) {
  const {data: fetchedAreas} = useAreas()
  const areas = fetchedAreas || []

  const hasSelectedArea = !!areas.find((a) => a.key === props.value)
  const value = hasSelectedArea ? props.value : ''

  return (
    <FormControl fullWidth>
      <InputLabel required={props.required}>Pick an area</InputLabel>
      <Select
        value={value}
        fullWidth
        onChange={onUnknownChangeHandler(props.onPick)}
        label="Source"
        inputProps={{
          'aria-label': 'pick area',
        }}
      >
        {areas.map((area) => (
          <MenuItem
            key={area.key}
            value={area.key}
            aria-label={`pick ${area.name}`}
          >
            {area.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
